<template>
    <b-card class="shadow-sm border" style="display: block;">
      <template #header>
        <b-container fluid>
          <b-row>
            <b-col>
              <slot name="title">
                <b>{{ title }}</b>
              </slot>
            </b-col>
            <b-button type="button" class="btn-filter-fold" :class="{ 'fold': isFilterFold }"
            @click="handleFilterFold" >
              <b-icon :icon="isFilterFold ? 'chevron-down' : 'chevron-up'"/>
            </b-button>
          </b-row>
        </b-container>
      </template>
      <template #default>
        <FlexibleGraphFilter v-show="!isFilterFold"
                            :metaData="dashboardData"
                            :componentName="componentName"
                            :filterType="filterType"
                            @update:filters="newFilters => filterData = newFilters"/>
        <div class="card-body p-0 d-flex align-items-center" style="height: 400px;">
          <component  v-if="dashboardData && filterData"
                    :is="componentName" 
                    :dashboardData="dashboardData"
                    :filters="filterData"
                    :isFlexible=true
                    :legendFontSize="20" />
        </div>
      </template>
    </b-card>
</template>
  <script>
  import FlexibleGraphFilter from './FlexibleGraphFilter2.vue';
  import ProjectStatusProgressGraph from './charts2/ProjectStatusProgressGraph.vue';
  import ProjectPlanAndActualGraph from './charts2/ProjectPlanAndActualGraph.vue';
  import ProjectOutputGraph from './charts2/ProjectOutputGraph.vue';
  import ProjectProductivityGraph from './charts2/ProjectProductivityGraph.vue';
  import ProgramTestDistributionGraph from './charts2/ProgramTestDistributionGraph.vue';
  import BugReportGraph from './charts2/BugReportGraph.vue';
  import ProgramCreationDateDistributionGraph from './charts2/ProgramCreationDateDistributionGraph.vue';
  import CompletionPeriodGraph from './charts2/CompletionPeriodGraph.vue';
  import CurrentStatusGraph from './charts2/CurrentStatusGraph.vue';
  import ChangedYesterdayGraph from './charts2/ChangedYesterdayGraph.vue';
  import ChangedTodayGraph from './charts2/ChangedTodayGraph.vue';
  import ProjectManMonthGraph from './charts2/ProjectManMonthGraph.vue';
  import ChatterActivationGraph from './charts2/ChatterActivationGraph.vue';
  import {BIcon} from 'bootstrap-vue'
  export default {
    name: "ChatterFlexibleDashboardCard2",
    props: [
        'title',
        'componentName',
        'dashboardData',
        'filterType'
    ],
    components: {
        FlexibleGraphFilter,
        ProjectStatusProgressGraph,
        ProjectPlanAndActualGraph,
        ProjectOutputGraph,
        ProjectProductivityGraph,
        ProgramTestDistributionGraph,
        BugReportGraph,
        CompletionPeriodGraph,
        ProgramCreationDateDistributionGraph,
        CurrentStatusGraph,
        ChangedYesterdayGraph,
        ChangedTodayGraph,
        ProjectManMonthGraph,
        ChatterActivationGraph,
        BIcon
    },
    created() {
      
    },
    data() {
        return {
            filterData: '',
            isFilterFold : true
        }
    },
    methods: {
        handleFilterFold() {
          this.isFilterFold = !this.isFilterFold;
        },
    }
  }
  </script>

<style scoped>
/* Customize the appearance of the accordion button */
.btn-filter-fold {
  background-color: #f8f9fa;
  color: #333;
  font-weight: bold;
}

/* Customize the appearance of the expanded accordion button */
.btn-filter-fold:not(.collapsed) {
  background-color: #e9ecef;
  color: #333;
}
</style>

<style>
.apexcharts-toolbar {
  max-width: unset !important;
  top: 20px !important;
  right: 20px !important;
  padding: 0 !important;
}

.apexcharts-menu-icon {
  display: flex;
  align-items: center;
  min-width: max-content;
  min-height: 40px;
  margin-left: 10px;
  padding-left: 10px;
  padding-right: 15px;
  border-radius: 4px;
  background: #E7E7EE;
  transform: scale(1) !important;
}
.apexcharts-menu-icon::before,
.apexcharts-menu-icon::after {
  content: '';
  display: inline-block;
  flex-shrink: 0;
}
.apexcharts-menu-icon::before {
  width: 20px;
  height: 20px;
  margin-right: 7px;
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10 10L10 15' stroke='%232E2E38' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12.5 13.3333L10 14.9999L7.5 13.3333' stroke='%232E2E38' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M15.0003 17.5H5.00033C4.54009 17.5 4.16699 17.1269 4.16699 16.6667L4.16699 3.33333C4.16699 2.8731 4.54009 2.5 5.00033 2.5L11.3029 2.5C11.535 2.5 11.7566 2.59683 11.9144 2.76716L15.6118 6.76038C15.7544 6.91442 15.8337 7.11662 15.8337 7.32656L15.8337 16.6667C15.8337 17.1269 15.4606 17.5 15.0003 17.5Z' stroke='%232E2E38' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M15.833 7.5L11.6663 7.5C11.2061 7.5 10.833 7.1269 10.833 6.66667L10.833 2.5' stroke='%232E2E38' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-size: contain;
}
.apexcharts-menu-icon::after {
  content: 'Graph Export';
  color: #000;
  font-family: NanumGothic;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.apexcharts-menu-icon svg {
  display: none;
}
</style>